<template>
    <div class="page-modal-container">
        <Modal class="page-modal"
               destroy-on-close
               v-model:visible="visible"
               width="90%"
               @close="onClose"
               :mask-closable="false"
               :body-style="{
               marginTop: '60px',
               minHeight: 'calc(100vh - 30px)'
           }">
            <template v-if="$slots.title" #title>
                <slot name="title"></slot>
            </template>
            <template #closeIcon><i class="pt-icons-close-page"></i></template>
            <InertiaModal/>
        </Modal>
    </div>
</template>

<script setup lang="ts">
import Modal from "@/Components/Common/Modal.vue";
import {provide, ref, watch} from "vue";
import {Modal as InertiaModal, useModal} from "@/packages/momentum-modal"

const {show: modalShow, redirect, close} = useModal()

let beforeCloseCallback
const visible = ref(modalShow.value)
watch(()=>modalShow.value, ()=>{
    visible.value = modalShow.value
})

provide('modalCloseCallback', (cb) => {
    beforeCloseCallback = cb
})

const onClose = () => {
    if (beforeCloseCallback && typeof beforeCloseCallback === 'function') {
        beforeCloseCallback()
    } else {
        // 延迟关闭，避免弹窗闪烁
        setTimeout(() => {
            redirect()
        }, 300)
    }
}

</script>

<style scoped lang="less">

</style>
